import { closestCenter, pointerWithin } from '@dnd-kit/core';

import { INVENTORY_DND_TYPE, INVENTORY_DROPZONE_DND_TYPE } from './dnd';

import type { EquipmentDragData } from './dnd';
import type { CollisionDetection } from '@dnd-kit/core';

export const getEquipmentDragData = (eventData: {
    current?: unknown;
}): EquipmentDragData | undefined => eventData.current as EquipmentDragData | undefined;

export const equipmentCollisionDetection: CollisionDetection = (args) => {
    const activeData = getEquipmentDragData(args.active.data);

    if (activeData?.type !== INVENTORY_DND_TYPE) {
        return closestCenter(args);
    }

    const pointerCollisions = pointerWithin(args);
    const hoveredWarehouseCollision = pointerCollisions.find((collision) => {
        const collisionData = getEquipmentDragData(collision.data?.droppableContainer.data);

        return (
            collisionData?.type === INVENTORY_DND_TYPE ||
            collisionData?.type === INVENTORY_DROPZONE_DND_TYPE
        );
    });
    const hoveredWarehouseData = hoveredWarehouseCollision
        ? getEquipmentDragData(hoveredWarehouseCollision.data?.droppableContainer.data)
        : undefined;

    if (
        hoveredWarehouseData?.type !== INVENTORY_DND_TYPE &&
        hoveredWarehouseData?.type !== INVENTORY_DROPZONE_DND_TYPE
    ) {
        return [];
    }

    const hoveredWarehouseId = hoveredWarehouseData.warehouseId;
    const warehouseInventoryContainers = args.droppableContainers.filter((container) => {
        const containerData = getEquipmentDragData(container.data);

        return (
            containerData?.type === INVENTORY_DND_TYPE &&
            containerData.warehouseId === hoveredWarehouseId
        );
    });
    const inventoryCollisions = closestCenter({
        ...args,
        droppableContainers: warehouseInventoryContainers,
    });

    if (inventoryCollisions.length > 0) {
        return inventoryCollisions;
    }

    return pointerCollisions.filter((collision) => {
        const collisionData = getEquipmentDragData(collision.data?.droppableContainer.data);

        return (
            collisionData?.type === INVENTORY_DROPZONE_DND_TYPE &&
            collisionData.warehouseId === hoveredWarehouseId
        );
    });
};
